const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockfi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#004bef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.9 436.9c41.5 41.5 41.5 108.7 0 149.7L587.1 736.9c-41.5 41.5-108.7 41.5-149.8 0L287.1 587.1c-41.5-41.5-41.5-108.7 0-149.8l149.7-150.2c19.9-19.9 46.9-31.1 75.1-31.1s55.2 11.2 75.1 31.1l149.9 149.8zM624.7 549.5c10-9.9 15.6-23.5 15.6-37.5s-5.6-27.6-15.6-37.5l-75.1-75.1c-9.9-10-23.5-15.6-37.5-15.6-14.1 0-27.6 5.6-37.5 15.6l-75.1 75.1c-10 9.9-15.6 23.5-15.6 37.5s5.6 27.6 15.6 37.5l75.1 75.1c9.9 10 23.5 15.6 37.5 15.6s27.6-5.6 37.5-15.6l75.1-75.1z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockfi);
export default __webpack_public_path__ + "static/media/blockfi.9639d245bc69480205ed4af273dc4677.svg";
export { ForwardRef as ReactComponent };